module.exports = __webpack_public_path__ + "static/logo-7ec1adb1fe483adc5c342d3f5840b6f5.png";